import { IPageContent } from '../../interfaces/common/content/page-content.interface';
import { ITransition } from '../../interfaces/onboarding/page-state/transition.interface';

export abstract class AbstractOnboardingPageComponent {
  abstract populatePageStates(transitions: ITransition[]): void;
  abstract populatePageContent(contentDict: Map<number, IPageContent>): void;
}
